import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';
import Input from 'Components/Atoms/Input/Input';
import IconButton from 'Components/Atoms/IconButton/IconButton';
import OutlineSearch from 'Components/Atoms/OutlineIcons/OutlineSearch';
import Icon from 'Components/Atoms/Icon/Icon';

function Search(props) {
    const { className, placeholder, value, onChange, onSearch, onClear, ...inputProps } = props;

    const handleSubmit = (e) => {
        e.preventDefault();
        if (onSearch) {
            onSearch(value);
        }
    };

    const showActions = value && value.length > 0;
    return (
        <form className={cn('relative group', className)} onSubmit={handleSubmit}>
            <Input
                type="search"
                placeholder={placeholder}
                value={value}
                onChange={(ev) => onChange(ev.target.value)}
                className={cn('pl-10 pr-3 [&::-webkit-search-cancel-button]:hidden', showActions && 'pr-17')}
                {...inputProps}
            />

            <OutlineSearch
                color="currentColor"
                className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none"
                size={20}
            />

            {showActions && (
                <div className="absolute right-2 top-1/2 flex gap-0.5 items-center -translate-y-1/2 text-gray-400">
                    <IconButton
                        icon={<Icon name="close" />}
                        variant="ghost"
                        size="small"
                        onClick={() => {
                            if (onClear) {
                                onClear();
                            } else {
                                onChange('');
                            }
                        }}
                    />

                    <IconButton
                        icon={<Icon name="arrow-right-small" />}
                        size="small"
                        variant="primary"
                        type="submit"
                        className="rounded-full"
                    />
                </div>
            )}
        </form>
    );
}

export default Search;

Search.propTypes = {
    className: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onSearch: PropTypes.func,
    onClear: PropTypes.func,
};
